import usePageContext, { PageContext } from "./usePageContext"

const path = process.env.PUBLIC_URL;

interface Theme {
    background: {
        path: string
    }
    logo: {
        path: string,
        height: number
    }
    color: {
        primary: string,
        primaryAccent: string,
    }
    phone: string,
    placeholder: string,
    privacyPolicy: string
}

const defaultTheme: Theme = {
    background: {
        path: ''
    },
    logo: {
        path: path + '/img/logos/conquer.svg',
        height: 50
    },
    color: {
        primary: '',
        primaryAccent: ''
    },
    phone: '551150395544',
    placeholder: 'Ex: João Silva',
    privacyPolicy: 'yellow'
}

const posTheme: Theme = {
    background: {
        path: ''
    },
    logo: {
        path: path + '/img/logos/conquer.svg',
        height: 50
    },
    color: {
        primary: '',
        primaryAccent: ''
    },
    phone: '551150395544',
    placeholder: 'Ex: João Silva',
    privacyPolicy: 'yellow'
}

const plusTheme: Theme = {
    background: {
        path: ''
    },
    logo: {
        path: path + '/img/logos/conquerAIPlus.png',
        height: 70
    },
    color: {
        primary: '',
        primaryAccent: ''
    },
    phone: '551150392943',
    placeholder: 'Ex: João Silva',
    privacyPolicy: 'yellow'
}

const elProfessorTheme: Theme = {
    background: {
        path: 'url(/img/backgrounds/bgElProfessor.png)'
    },
    logo: {
        path: path + '/img/logos/elProfessor.svg',
        height: 80
    },
    color: {
        primary: '#1e93f9',
        primaryAccent: 'white'
    },
    phone: '',
    placeholder: 'Ex: João Silva',
    privacyPolicy: 'yellow'
}

const unnaTheme: Theme = {
    background: {
        path: ''
    },
    logo: {
        path: path + '/img/logos/conquerUnna.svg',
        height: 30
    },
    color: {
        primary: '#b891e0',
        primaryAccent: ''
    },
    phone: '551150398434',
    placeholder: 'Ex: Ana Paula',
    privacyPolicy: '#b891e0'
}

const wolTheme: Theme = {
    background: {
        path: ''
    },
    logo: {
        path: path + '/img/logos/wol.svg',
        height: 40
    },
    color: {
        primary: '#a70240',
        primaryAccent: 'white'
    },
    phone: '551150397141',
    placeholder: 'Ex: João Silva',
    privacyPolicy: 'white'
}

const iaBuilderTheme: Theme = {
    background: {
        path: ''
    },
    logo: {
        path: path + '/img/logos/ia-builder-logo.png',
        height: 30
    },
    color: {
        primary: '#FF7346',
        primaryAccent: ''
    },
    phone: '551150391232',
    placeholder: 'Ex: João Silva',
    privacyPolicy: '#FF7346'
}

const mbaIaBusinessTheme: Theme = {
    background: {
        path: ''
    },
    logo: {
        path: path + '/img/logos/mba-ia-logo.png',
        height: 30
    },
    color: {
        primary: '#FEF2DB',
        primaryAccent: ''
    },
    phone: '551150399399',
    placeholder: 'Ex: João Silva',
    privacyPolicy: '#FEF2DB'
}

const getByContext = (ctx: PageContext) => {
    switch (ctx) {
        case PageContext.CONQUER_PLUS: return plusTheme;
        case PageContext.CONQUER_POS: return posTheme;
        case PageContext.EL_PROFESSOR: return elProfessorTheme;
        case PageContext.UNNA: return unnaTheme;
        case PageContext.WOL: return wolTheme;
        case PageContext.IA_BUILDER: return iaBuilderTheme;
        case PageContext.MBA_IA_BUSINESS: return mbaIaBusinessTheme;
        default: return defaultTheme;
    }
}

export function useTheme() {

    const { context } = usePageContext();

    return { theme: getByContext(context) }
}